import { ArrowRight, Wallet } from 'lucide-react';
import { Link } from 'react-router-dom';

import { formatCurrency } from '@/utils/format';

interface PendingPayoutsSectionProps {
  amount: number;
  currency: string;
}

/**
 * Dashboard callout card showing the total pending payout amount owed to
 * dispatch place partners, with a direct link to the Finances section.
 */
export function PendingPayoutsSection(props: PendingPayoutsSectionProps) {
  return (
    <section className="flex flex-col gap-4">
      <h2 className="text-xl font-semibold">Pagos pendientes a puntos</h2>

      <div className="card border border-warning/40 bg-warning/5">
        <div className="card-body flex-row items-center gap-5 p-5">
          <div className="rounded-box bg-warning/15 p-4 text-warning">
            <Wallet className="h-8 w-8" />
          </div>
          <div className="flex flex-1 flex-col gap-0.5">
            <span className="text-sm text-base-content/60">Monto pendiente de liquidar</span>
            <span className="text-3xl font-bold text-warning">
              {formatCurrency(props.amount, props.currency)}
            </span>
            <span className="text-xs text-base-content/50">
              Acumulado de liquidaciones semanales pendientes a los puntos de la red.
            </span>
          </div>
          <Link to="/finances" className="btn btn-warning btn-outline btn-sm gap-1 shrink-0">
            Ver finanzas
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
